import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from '../../components/SnackbarProvider';
import { JobsiteService, JobsiteUpdateDTO } from '../generated';
import { jobsiteKeys } from '../queries/jobsite';
import { userKeys } from '../queries/user';

export interface UpdateJobsiteProps {
  organisationId: string;
  jobsiteId: string;
  data: JobsiteUpdateDTO;
}

export function useUpdateJobsiteMutation() {
  const { showSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organisationId, jobsiteId, data }: UpdateJobsiteProps) =>
      JobsiteService.jobsiteControllerUpdateJobsite({
        path: { organisationId: organisationId, jobsiteId: jobsiteId },
        body: data,
      }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: jobsiteKeys.base,
        }),
        queryClient.invalidateQueries({
          queryKey: userKeys.base,
        }),
      ]);

      showSnackbar('administration.locationManagement.changeNameSuccess', 'success');
    },
    onError: () => {
      showSnackbar('error.default', 'error');
    },
  });
}
